// extracted by mini-css-extract-plugin
export default {"overlay":"NoDocumentsOverlay_overlay__pC763","dragActive":"NoDocumentsOverlay_dragActive__cSaHk"};